export default __webpack_public_path__ + "static/media/icon-disabilities-inverted.2bf8c3dc.svg";